<script setup lang="ts">
  import { TravelDurationWidget } from '@/widgets'
</script>

<template>
  <TravelDurationWidget />
</template>
